import React, { useRef, useState } from 'react';
import { ChatEmailAlertPanel } from 'src/common/chat/email-alert-panel';
import { Nullable } from 'src/types/nullable.type';
import { functionNoop } from 'src/utils/function/noop';
import { DashboardInboxMenu, DashboardInboxMenuProps } from '.';
import { useChatChangeSubscription } from 'src/common/chat/change-subscription.hook';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { useDashboardInboxStore } from '../store';
import { ChatSubscriptionTypeEnum } from 'src/common/chat/subscription-type.enum';

export type DashboardInboxMenuOptionsActionPanelTypes = 'notification';

interface Props extends Pick<DashboardInboxMenuProps, 'renderMenuOrigin' | 'placement'> {
  onMenuOpen: () => void;
  aliasUUID: JourneyAlias['uuid'];
  isSubscribed: boolean;
  onMenuClose: () => void;
}

export const DashboardInboxMenuOptions = ({
  aliasUUID,
  placement,
  isSubscribed,
  renderMenuOrigin,
  onMenuClose,
  onMenuOpen,
}: Props) => {
  const updateSubscriptionTypeByAliasUUID = useDashboardInboxStore((state) => state.updateSubscriptionTypeByAliasUUID);
  const { updateSubscription } = useChatChangeSubscription();
  const [isEnabled, setIsEnabled] = useState(isSubscribed);
  const [activePanel, setActivePanel] = useState<Nullable<DashboardInboxMenuOptionsActionPanelTypes>>(null);

  const menuOpenRef = useRef(functionNoop);
  const menuCloseRef = useRef(functionNoop);

  const notificationsMenuOpenRef = useRef(functionNoop);
  const notificationsMenuCloseRef = useRef(functionNoop);

  const onMenuClicked = () => {
    menuOpenRef.current();
  };

  const onBack = () => {
    setActivePanel(null);
    setTimeout(onMenuClicked, 50);
  };

  const subscriptionType = isEnabled ? null : ChatSubscriptionTypeEnum.ALIAS;

  const onClosePanel = () => {
    updateSubscriptionTypeByAliasUUID(aliasUUID, subscriptionType);
    onMenuClose();
  };

  const onEmailAlertToggleChanged = (value: boolean) => {
    setIsEnabled(value);
    updateSubscription(aliasUUID, value);
  };

  if (activePanel === 'notification') {
    return (
      <ChatEmailAlertPanel
        openAfterMount
        placement={placement}
        onChange={onEmailAlertToggleChanged}
        isEnabled={isEnabled}
        renderOrigin={() => renderMenuOrigin(onMenuClicked)}
        onBack={onBack}
        onClose={onClosePanel}
        onOpen={onMenuOpen}
        openRef={notificationsMenuOpenRef}
        closeRef={notificationsMenuCloseRef}
      />
    );
  }

  return (
    <DashboardInboxMenu
      renderMenuOrigin={renderMenuOrigin}
      isLinkLevelSubscriptionEnabled={isEnabled}
      onOpen={onMenuOpen}
      onClose={onMenuClose}
      openRef={menuOpenRef}
      closeRef={menuCloseRef}
      onItemClick={setActivePanel}
    />
  );
};
